const property = [
  { label: 'Kein Immobilienbesitz', value: 'NONE' },
  { label: 'Eigentumswohnung', value: 'APPARTMENT' },
  { label: 'Einfamilienhaus', value: 'SINGLE_FAMILY_HOUSE' },
  { label: 'Mehrfamilienhaus', value: 'APPARTMENT_HOUSE' },
  { label: 'Büro-/Geschäftsgebäude', value: 'OFFICE' }
]

export default property
